import { parsedToken } from "../../service/storageHelper";
import indexer, { jwtToken, IListObj } from "../../types/genericTypes";
import { IMFCancel, IMF, IMFSip, IMFHold } from "../../types/components/orderBook/obTypes";
import { CSSProperties, useState } from "react";
import DeviceContext from "../../service/indentifyDevice";

export const secNavOptions = () => {
	let pToken: jwtToken | null = parsedToken();

	if (pToken && pToken.accType === "EQ") {
		return [
			{ value: "equity", display: "Equity", href: eqNav.today },
			{ value: "mf", display: "Mutual Funds", href: mfNav.today },
			{ value: "derivative", display: "Derivatives", href: dervNav.today },
			{ value: "currency", display: "Currency", href: currNav.today },
			{ value: "pm", display: "New Offers", href: "/orderbook/newoffers/pm/ipo/today" }
		];
	} else if (pToken && pToken.accType === "CO") {
		return [{ value: "commodities", display: "Commodities", href: commNav.today }];
	} else if (pToken && pToken.accType === "COMEQ") {
		return [
			{ value: "equity", display: "Equity", href: eqNav.today },
			{ value: "commodities", display: "Commodities", href: commNav.today },
			{ value: "mf", display: "Mutual Funds", href: mfNav.today },
			{ value: "derivative", display: "Derivatives", href: dervNav.today },
			{ value: "currency", display: "Currency", href: currNav.today },
			{ value: "pm", display: "New Offers", href: "/orderbook/newoffers/pm/ipo/today" }
		];
	} else {
		return [
			{
				value: "",
				display: "",
				href: ""
			}
		];
	}
};
export const ChipColorKeyComb: indexer = {
	rejected: "red",
	open: "blue",
	pending: "blue",
	failed: "red",
	cancelled: "red",
	"on hold": "yellow",
	completed: "green",
	complete: "green",
	accepted: "blue",
	ordered: "green",
	"cancelled after market order": "red",
	"after market order req received": "blue",
	"after market order": "blue",
	amo: "blue",
	"trigger pending": "blue",
	"in process": "blue",
	"validation rejected": "red",
	"open pending": "blue",
	"offline waiting": "blue",
	"modify after market order req received": "blue",
	"registered by member": "blue",
	approved: "green",
	success: "green",
	"after market order (AMO)": "blue",
	inprocess: "blue",
	running: "blue",
	active: "blue",
	"put order req received": "blue"
};
// status for all instrument except MF
export const ChipStatusComb: indexer = {
	open: "open",
	"put order req received": "in process",
	"modify after market order req received": "open",
	"after market order req received": "amo",
	"after market order": "amo",

	pending: "tr. pending",
	"trigger pending": "tr. pending",
	"open pending": "tr. pending",
	"offline waiting": "tr. pending",
	"on hold": "on hold",
	completed: "completed",
	complete: "completed",
	accepted: "accepted",
	ordered: "completed",
	rejected: "rejected",
	"validation rejected": "rejected",
	failed: "cancelled",
	cancelled: "cancelled",
	"cancelled after market order": "cancelled",
	"registered by member": "registered by member",
	approved: "approved",
	success: "success",
	"in process": "in process",
	inprocess: "in process",
	running: "active"
};

// status for MF
export const ChipStatusMfComb: indexer = {
	complete: "completed",
	ordered: "completed",
	accepted: "completed",
	rejected: "rejected",
	failed: "cancelled",
	cancelled: "cancelled",
	"cancelled after market order": "cancelled",
	"in process": "in process",
	inprocess: "in process",

	//Need to check whata extactly status need to show

	// "after market order req received": "after market order (AMO)",
	// "after market order": "after market order (AMO)"
	"after market order req received": "AMO",
	"after market order": "AMO"
};

// status for MF SIP
export const ChipStatusMfSipComb: indexer = {
	active: "running",
	inactive: "not running"
};

//open orders possible states across all asset classes will be included here
export const openStatusArr: Array<string> = [
	"open",
	"after market order",
	"after market order req received",
	"trigger pending",
	"in process",
	"open pending",
	"pending",
	"modify after market order req received",
	"put order req received"
];

export const ovrOptions: Array<IListObj> = [
	{ value: "Modify", display: "Modify" }, //0
	{ value: "cancel", display: "Cancel" }, //1
	{ value: "Convert", display: "Convert" }, //2
	{ value: "Retry", display: "Retry" }, //3
	{ value: "details", display: "Details" } //4
];
//instrument navigation in P2
export const newOfferOptions: Array<IListObj> = [
	{
		value: "ipo",
		display: "IPO",
		href: "/orderbook/newoffers/pm/ipo/today"
	},
	{
		value: "ncd",
		display: "NCD",
		href: "/orderbook/newoffers/pm/ncd/today"
	},

	// {
	// 	value: "ofs",
	// 	display: "OFS",
	// 	href: "/orderbook/newoffers/pm/ofs/today"
	// },
	{
		value: "nfo",
		display: "NFO",
		href: "/orderbook/newoffers/pm/nfo/today"
	}
];

//equity navigation url - one point ref changing static path'/orderbook/eq/' requries change in routing file as well
export const eqNav = {
	today: "/orderbook/eq/equity/today",
	history: "/orderbook/eq/equity/history",
	sip: "/orderbook/eq/equity/sip"
};
//mf navigation url - one point ref changing static path'/orderbook/mf/' requries change in routing file as well

export const mfNav = {
	today: "/orderbook/mf/mf/today",
	history: "/orderbook/mf/mf/history",
	sip: "/orderbook/mf/mf/sip"
};
//commodity navigation url - one point ref changing static path'/orderbook/comm/' requries change in routing file as well

export const commNav = {
	today: "/orderbook/comm/commodities/today",
	history: "/orderbook/comm/commodities/history"
};
//derivative navigation url - one point ref changing static path'/orderbook/derivative/' requries change in routing file as well

export const dervNav = {
	today: "/orderbook/derivative/derivative/today",
	history: "/orderbook/derivative/derivative/history"
};
//currency navigation url - one point ref changing static path'/orderbook/currency/' requries change in routing file as well

export const currNav = {
	today: "/orderbook/currency/currency/today",
	history: "/orderbook/currency/currency/history"
};
export enum scrlStCls {
	freeze = "freeze", //rows to be freezed
	toContext = "flwCont", //context ref where rows to be freezed until this context is visible and near to table fixed header(pOffset)
	pOffset = "refOffset", //ref class added to table fixed header
	pContId = "scrlContainer", //container where synthetic event attached
	fixClass = "fix" //class to add to (freeze)
}
//custom hook to compute max height based on the api response data
export const ObScrollStyle = (setMinMax: boolean): CSSProperties => {
	const [computedStyles, setcomputedStyles] = useState<CSSProperties>({});
	const ele = document.querySelector("body") as HTMLElement;
	//on rough guess this offset has been set - should be changed to accurate values
	const offset: string = DeviceContext().isMobile ? "120px" : "220px";
	if (setMinMax) {
		setTimeout(() => {
			if (ele.scrollHeight > window.innerHeight) {
				setcomputedStyles({
					maxHeight: "calc(" + window.innerHeight + "px - " + offset + ")",
					overflowY: "auto"
				});
			}
		}, 350);
	}

	return computedStyles;
};

export const PMErrorMessages: indexer = {
	ipo: "There are no IPO orders placed by you today",
	ofs: "You haven`t placed any OFS orders today",
	nfo: "You haven`t placed any NFO orders today",
	ncd: "There are no NCD orders placed by you today"
};
export default secNavOptions;

export const getMFCancelObj = (data: IMF | IMFSip | IMFHold): IMFCancel => {
	let cancelObj: IMFCancel = {
		currentOrdSts: "ordStatus" in data ? data.ordStatus : "",
		token: "token" in data ? data.token : "",
		isin: data.isin,
		txnTyp: data.status.toLowerCase() !== "amo" ? data.txnType : "AMO",
		clientCode: parsedToken()?.username || "",
		qty: parseFloat(data.units),
		amt: parseFloat(data.amount),
		reInvFlg: "reinvestmentFlag" in data ? data.reinvestmentFlag : "",
		reqstdBy: "",
		folioNo: data.folioNo,
		ordTyp: "cancel",
		txnId: parseInt(data.txnID),
		schemeName: data.schemeName,
		rmrk: "remarks" in data ? data.remarks : "",
		mnRdmFlg: data.txnType === "R" ? "Y" : "",
		ordSrc: "TOCMF",
		strtDy: "startDay" in data ? new Date(data.startDay).getDay() : new Date().getDay(),
		strtDt: data.startDate,
		endDt: data.endDate,
		sipFrq: "sipfrequency" in data ? data.sipfrequency : "",
		gfot: "",
		tnr: "tenure" in data ? data.tenure : "",
		mdtId: data.mandateID,
		sipregno: "sipregNo" in data ? data.sipregNo : "",
		siporderno: "siporderNo" in data ? data.siporderNo : "",
		closeAccountFlag: "string",
		kycflag: "1",
		dpc: data.dpc,
		euinflag: "N",
		euinnumber: "",
		physicalFlag: "physicalFlag" in data ? data.physicalFlag : ""
	};
	if (data.status.toLowerCase() === "on hold") {
		cancelObj = {
			...cancelObj,
			currentOrdSts: "ACCEPTED",
			reInvFlg: "option" in data ? (data.option === "Div.Reinvestment" ? "Y" : data.option === "Div.Payout" ? "N" : "Z") : "Z"
		};
	}
	return cancelObj;
};
